import React, { useState, useRef } from 'react';

import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { TextBox } from "@progress/kendo-react-inputs";

import useSession from '../../hooks/useSession';

const EMPTY_VALUE = "";

const SearchWidget = ({ state, prefKey, refresh, toolTip = "Search By Name and Description" }) => {

	const [searchValue, setSearchValue] = useState(state.searchStr);
	const { setPreference } = useSession();
	const buttonRef = useRef();

	const handleChange = (event) => {
		setSearchValue(event.target.value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		handleSearch(searchValue);
	};
	
	const searchButtonClicked = () => {
		handleSearch(searchValue);
	};
	
	const clearButtonClicked = () => {
		setSearchValue(EMPTY_VALUE);
		handleSearch(EMPTY_VALUE);
	};

	const handleSearch = (newSearchValue) => {
		if (prefKey) 
			setPreference(prefKey + "_SEARCH", newSearchValue);
		state.searchStr = newSearchValue;
		refresh();
	};
	
	const handleInputKeyDown = (event) => {
		if (event.key == 'Enter') 
			handleSubmit(event);
		else if (event.key == 'Tab') {
			event.preventDefault();
			buttonRef.current.element.focus();
		}
	};

	return (
		<span>
			<TextBox
				role="button"
				key={"searchStr"}
				field={"searchStr"}
				maxLength={500}
				value={searchValue}
				onChange={handleChange}
				onKeyDown={handleInputKeyDown}
				title={toolTip}
			/>
			<form
				onSubmit={handleSubmit}
			>
					<ButtonGroup>
					<Button
						ref={buttonRef}
						key={"search"}
						iconClass={"fa fa-fw fa-small fa-search"}
						className='searchBtn'
						onClick={searchButtonClicked}
						title={toolTip}
					/>
					<Button
						key={"clear"}
						iconClass={"fa fa-fw fa-small fa-cancel"}
						className='clearBtn'
						onClick={clearButtonClicked}
						title={"Clear Search"}
					/>
				</ButtonGroup>
			</form>
		</span>
	);
}

export default SearchWidget;	